(function (upp) {
    'use strict';

    upp.directive('monthCalendar', [function () {
        return {
            restrict: 'E',
            templateUrl: require('../templates/calendar-monthly_calendar.html'),
            controller: ['$scope', 'calendarUtil', function ($scope, calendarUtil) {
                /**
                 * Renders the next month
                 */
                $scope.prevMonth = function () {
                    $scope.date.month--;
                    if ($scope.date.month < 0) {
                        $scope.date.year--;
                        $scope.date.month = 11;
                    }

                    $scope.$emit('calendar:reloadMonth', $scope.date);
                };

                /**
                 * Renders the previous month
                 */
                $scope.nextMonth = function () {
                    $scope.date.month++;
                    if ($scope.date.month > 11) {
                        $scope.date.year++;
                        $scope.date.month = 0;
                    }

                    $scope.$emit('calendar:reloadMonth', $scope.date);
                };

                /**
                 * A day has been selected. When the day is selected an event is emitted to all parent controllers
                 * with the date of the selected day.
                 * @param day
                 * @param month
                 * @param year
                 */
                $scope.daySelected = function (day, month, year) {
                    if (Number(day) > 0) {
                        $scope.date.day = day;
                        $scope.date.month = month;
                        $scope.date.year = year;
                    }

                    $scope.$emit('calendar:daySelected', $scope.date);
                };

                $scope = angular.extend($scope, calendarUtil);
            }],
            transclude: true,
            scope: {
                date: '=',
                data: '=',
                calendar: '='
            }
        }
    }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/booking/directives/booking-calendar-directive.js